import { FC, useContext } from 'react';
import { Button } from '@cfa/react-core';
import SupportAppQRCode from '../../assets/qr-support-ldpi.svg';
import { themeColors, themeSizes } from '../../styles/globalStyleVars';
import styled from 'styled-components';
import { UserContext } from '../../user/UserContext';
import { UserContextType } from '../../@types/user';
import { TypographyStyled } from '../Styled/Typography';

const QRWrapper = styled.div<{
  $isLgAndUp: boolean;
}>`
  background: ${themeColors.notificationBackgroundColor};
  border-radius: ${themeSizes.sm};
  display: flex;
  align-items: center;
  justify-content: center;
  margin: ${themeSizes.xl} ${({ $isLgAndUp }) => ($isLgAndUp ? '39px' : '0')} 0
    0;
  padding: ${themeSizes.sm};
`;

export const DownloadAppQRWithText: FC<{
  text: string;
  isLgAndUp: boolean;
}> = ({ text, isLgAndUp }) => {
  const { userState } = useContext(UserContext) as UserContextType;

  const handleAppContentClick = () => {
    if (userState.mobileOS) {
      window.open(
        import.meta.env.VITE_SUPPORT_APP_DOWNLOAD,
        '_blank',
        'noreferrer'
      );
    }
    return;
  };

  return (
    <QRWrapper $isLgAndUp={isLgAndUp}>
      {isLgAndUp ? (
        <>
          <span>
            <img
              src={SupportAppQRCode}
              style={{
                paddingRight: themeSizes.smMd,
                height: '100px',
                width: '100px',
              }}
              alt='Support App QR Code'
            />
          </span>
          <span>
            <TypographyStyled
              text={text}
              variant='body2'
              color={themeColors.colorGray_7}
              fontWeight='medium'
            />
          </span>
        </>
      ) : (
        <span style={{ textAlign: 'center' }}>
          <TypographyStyled
            text='Use the Support App to scan your equipment asset tag and find it
            faster.'
            variant='body2'
            color={themeColors.colorGray_7}
            fontWeight='medium'
          />
          <Button
            variant='text'
            color='secondary'
            onPress={handleAppContentClick}
            style={{
              fontSize: '14px',
              paddingTop: themeSizes.md,
            }}
          >
            Open Support App
          </Button>
        </span>
      )}
    </QRWrapper>
  );
};
